import { useUserStoreHook } from '@/store/user'

const splitPermissionString = (str) => {
  try {
    if (typeof str === 'string' && str.includes('::')) {
      const [firstPart, secondPart] = str.split('::')
      return [firstPart.trim(), secondPart.trim()]
    } else {
      throw new Error('Invalid permission string or delimiter not found')
    }
  } catch (error) {
    console.error(error.message)
    return []
  }
}

function get_module (routes, modulename) {
  for (let index = 0; index < routes.length; index++) {
    const item = routes[index]
    if (item.code == modulename) {
      return item
    } else {
      if (item.child && item.child.length != 0) {
        const result = get_module(item.child, modulename)
        if (result) {
          return result
        }
      }
    }
  }
}

const store = useUserStoreHook()

export default {
  async mounted (el, options) {
    // 立即隐藏元素，直到权限验证完成
    el.style.display = 'none'
    
    try {
      const routes = await store.getRoutes()
      let ishasPermission = false

      if (options.value && options.value.indexOf('::') == -1) {
        const _moduleItem = get_module(routes, options.value)
        ishasPermission = _moduleItem
      } else {
        const [module = null, operate = null] = splitPermissionString(options.value)
        const _moduleItem = get_module(routes, module)
        ishasPermission = _moduleItem?.child?.find(x => x.code == operate)
      }

      if (ishasPermission) {
        el.style.display = '' 
      } else {
        el.parentNode?.removeChild(el) // 移除元素
      }
    } catch (error) {
      console.error('Permission check error:', error)
      el.parentNode?.removeChild(el)
    }
  }
}